<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h1 class="d-inline-block mb-0">Fall - {{incident.number}} - {{incident.briefDescription}}</h1>
                        <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                                <route-bread-crumb></route-bread-crumb>
                                            </nav>-->
                    </div>
                    <div class="col-lg-6 col-5 text-right">
                        <!--                    <base-button size="sm" type="neutral">New</base-button>
                                            <base-button size="sm" type="neutral">Filters</base-button>-->
                    </div>
                </div>
            <base-alert v-if="error.length > 0" type="danger">
                <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
            </base-alert>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-3 order-xl-1 mb-5 mb-xl-0">
                    <card shadow type="secondary">
                        <template v-slot:header class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0"> {{
                                            (incident.callerBranch) ? incident.callerBranch.name : ''
                                        }}</h3>
                                </div>
                            </div>
                        </template>
                        <template v-slot>
                            <div>{{ (incident.caller) ? incident.caller.dynamicName : '' }}</div>
                        </template>
                    </card>
                    <card shadow type="secondary">
                        <template v-slot:header class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Planung</h3>
                                </div>
                            </div>
                        </template>
                        <template v-slot>
                            <div class="row">
                                <div class="col">Laufzeit:</div>
                                <div class="col text-right">{{
                                        (incident.duration) ? incident.duration.name : ''
                                    }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">Termin:</div>
                                <div class="col text-right"> {{ convertDate(incident.targetDate) }}</div>
                            </div>
                        </template>
                    </card>
                    <card shadow type="secondary">
                        <template v-slot:header class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Bearbeitung</h3>
                                </div>
                            </div>
                        </template>
                        <template v-slot>
                            <div class="row">
                                <div class="col">Bearbeiter:</div>
                                <div class="col text-right">{{
                                        (incident.operator) ? incident.operator.name : ''
                                    }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">Bearbeitergruppe:</div>
                                <div class="col text-right"> {{
                                        (incident.operatorGroup) ? incident.operatorGroup.name : ''
                                    }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">Status:</div>
                                <div class="col text-right"><i
                                    :class="{'fad fa-lock': incident.closed, 'fad fa-lock-open text-primary': !incident.closed}"></i>
                                </div>
                            </div>
                            <hr>
                            <div v-if="incident.closed && incident.closedDate" class="row">
                                <div class="col">Geschlossen:</div>
                                <div class="col text-right">{{ convertDate(incident.closedDate) }}</div>
                            </div>
                            <div v-if="!incident.closed">
<!--                                <button v-if="!closer" class="btn btn-warning btn-block mt-3"
                                        @click.prevent="closer = !closer">
                                    Schliessen
                                </button>
                                <transition name="fade">
                                    <form v-if="closer" id="closeForm" @submit.prevent="processClosing">
                                        <ckeditor class="form-control" v-model="closeText" :editor="editor"
                                                  :config="editorConfig" :rows="4" required></ckeditor>
                                        <div><small class="font-italic">Bilder bis max 450px</small></div>
                                        <small class="errorText" v-if="errorCloseText.length > 0">{{
                                                errorCloseText
                                            }}</small>
                                        <button v-bind:disabled="disabled"
                                                class="btn btn-warning btn-sm btn-block mt-3"
                                                type="submit">Schliessung
                                            bestätigen
                                        </button>
                                    </form>
                                </transition>-->
                            </div>
                            <div v-if="incident.closed">
                                <button v-if="!reOpener" class="btn btn-primary btn-block mt-3"
                                        @click.prevent="reOpener = !reOpener">
                                    Erneut öffnen
                                </button>
                                <transition name="fade">
                                    <form v-if="reOpener" id="openForm" @submit.prevent="processReOpening">
                                        <ckeditor class="form-control" v-model="openText" :editor="editor"
                                                  :config="editorConfig" :rows="4" required></ckeditor>
                                        <div><small class="font-italic">Bilder bis max 450px können in den Text eingefügt werden. Grössere Bilder bitte als Anhang versenden</small></div>
                                        <dropzone-file-upload ref="dropzoneInstance" :options="dropzoneOptions"
                                                              v-model="dropzoneFiles" class="mt-3"
                                                              multiple></dropzone-file-upload>
                                        <small class="errorText" v-if="errorOpenText.length > 0">{{
                                                errorOpenText
                                            }}</small>
                                        <button v-bind:disabled="disabled"
                                                class="btn btn-primary btn-sm btn-block mt-3"
                                                type="submit">Wiederöffnung
                                            bestätigen
                                        </button>
                                    </form>
                                </transition>
                            </div>
                        </template>
                    </card>
                </div>
                <div class="col col-xl-9 order-xl-2">
                    <card shadow type="secondary">
                        <template v-slot:header class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">
<!--                                        <a v-if="currentUser.roles.indexOf('topdesk_admin') !== -1" @click.stop
                                           target="_blank"
                                           :href="'https://topdesk.talus.ch/tas/secure/contained/incident?unid=' + incident.id">
                                            {{ incident.number }}
                                        </a>-->
                                        {{ incident.number }}
<!--                                        <a v-if="currentUser.roles.indexOf('topdesk_admin') === -1" @click.stop
                                           target="_blank"
                                           :href="'https://servicedesk.talus.ch/tas/public/contained/incidentpublic?unid=' + incident.id">
                                            {{ incident.number }}
                                        </a>-->
                                        <b class="ml-4">
                                            {{
                                                (incident.status == 'firstLine') ? '1st-Level' :
                                                    '2nd-Level'
                                            }}
                                        </b>
                                    </h3>
                                </div>
                                <div class="col-4 text-right">
                                    <small
                                        class="text-muted font-italic">{{ convertDate(incident.callDate) }}</small>
                                </div>
                            </div>
                        </template>
                        <template v-slot>
                            <h3 v-if="request.person"><i class="fad fa-envelope-open-text"></i> {{ request.person.name }}</h3>
                            <h3 v-if="request.operator"><i class="fad fa-envelope-open-text"></i> {{ request.operator.name }}</h3>
                            <span v-if="request.memoText" v-html="formatLinksInText(request.memoText)" @click.prevent="openImagePreview"></span>
                        </template>
                    </card>
                    <card shadow type="white">
                        <template v-if="!incident.closed" v-slot:header class="bg-white border-0">
                            <form id="newCommentForm" @submit.prevent="processForm">
                                <ckeditor class="form-control" v-model="newComment" :editor="editor"
                                          :config="editorConfig" :rows="4" required></ckeditor>
                                <small class="errorText" v-if="errorComment.length > 0">{{ errorComment }}</small>
                                <div><small class="font-italic">Bilder bis max 450px können in den Text eingefügt werden. Grössere Bilder bitte als Anhang versenden</small></div>
                                <dropzone-file-upload ref="dropzoneInstance" :options="dropzoneOptions"
                                                      v-model="dropzoneFiles" class="mt-3"
                                                      multiple></dropzone-file-upload>
                                <button v-bind:disabled="disabled" class="btn btn-primary btn-sm float-right"
                                        type="submit">Antworten
                                </button>
                            </form>
                        </template>
                        <template v-slot>
                            <div v-if="incident.actions">
                                <div v-for="(action, index) in actions" :key="index">
                                    <div
                                        v-if="!(currentUser.roles.indexOf('topdesk_admin') === -1 && action.invisibleForCaller)">
                                        <hr v-if="index !== 0">
                                        <div class="row align-items-center">
                                            <div class="col-8">
                                                <h3 v-if="action.person"><i class="fad fa-paper-plane"></i>
                                                    {{ action.person.name }}</h3>
                                                <h3 v-if="action.operator"><i class="fad fa-paper-plane"></i>
                                                    {{ action.operator.name }}</h3>
                                                <h3 v-if="!action.operator && !action.person"><i class="fad fa-server"></i>
                                                    System</h3>
                                            </div>
                                            <div class="col-4 text-right">
                                                <small
                                                    class="text-muted font-italic">{{
                                                        convertDate(action.entryDate)
                                                    }}</small>
                                            </div>
                                        </div>
                                        <p v-if="action.memoText" v-html="formatLinksInText(action.memoText)" @click.prevent="openImagePreview"></p>

                                        <!-- fetch data, forge a download link and save (above only opens new window for Top Desk) -->
                                        <a
                                            v-if="action.fileName" @click="getAndDownloadSingleAttachment(incident.id, action.id)"
                                            :href="downloadLink"
                                            :download="action.fileName"
                                        >
                                            {{action.fileName}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </card>

                    <!-- collection of modals here -->
                    <modal v-model:show="showImagePreview" modal-classes="modal-lg modal-dialog-centered">
                        <template v-slot:header>
                            <h4 class="modal-title" id="exampleModalLabel">Vorschau</h4><br>
                        </template>
                        <a :href="imagePreviewBlob.url" :download="'myTalus ' + imagePreviewBlob.fileName" style="display: block; width: 100%; padding: 8px; cursor: pointer;">
                            <el-tooltip :disabled="disabled" content="Herunterladen" effect="dark">
                                <img :src="imagePreviewBlob.url" alt="Full-Scale Image" style="width: 100%;">
                            </el-tooltip>
                        </a>
                        <template v-slot:footer>
                            <base-button :disabled="disabled" title="Schliessen" @click.prevent="showImagePreview = !showImagePreview"
                                         type="success">
                                Schliessen
                            </base-button>
                        </template>
                    </modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/de';
import UserService from '@/services/user.service';
import Card from '@/components/Cards/Card';
import BaseAlert from '@/components/BaseAlert';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import Modal from "../../../components/Modal.vue";
import BaseButton from "../../../components/BaseButton.vue";
import incident from "./Incident.vue";

export default {
    name: 'tables',
    components: {
        BaseButton,
	Modal,
        BaseAlert,
        Card,
        DropzoneFileUpload,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user
        }
    },
    methods: {
        getAndDownloadSingleAttachment(incidentId, attachmentId) {
            // a temporary link is forged and set as downloadlink variable to be used in the anchor tag
            UserService.getSingleAttachment(incidentId, attachmentId).then(link => {
                this.downloadLink = link
                console.log('this.download link ref: ', this.downloadLink)
            })
        },
        formatIncidentText(value) {
            return "<b>" + this.currentUser.family_name + ", " + this.currentUser.given_name + "</b><br><br>" + value.replace(/<p>/gm, '').replace(/<\/p>/gm, '<br>').replace(/<\/figure>/gm, '').replace(/<figure.+?>/gm, '');
        },
        formatLinksInText(value) {
            return value
            // this code may be deprecated - advise Dan Eisner
            // return value.replace(/\/tas\//gm, 'https://topdesk.talus.ch/tas/').replace(/a href/gm, 'a target="_blank" href');
        },

        // ***  image preview modal and fetch from attachments  ***
        async openImagePreview(event) {
            event.preventDefault()
            let imageFileName = this.extractImageFileNameFromLink(event)
            if (!imageFileName) return // clicked on preview only image
            let attachmentIdForFileName = this.extractAttachmentIdForFileName(imageFileName, this.incident.attachments.data)
            this.imagePreviewBlob = await this.fetchFullScaleImage(this.incidentId, attachmentIdForFileName, imageFileName)
            this.showImagePreview = true
        },
        extractImageFileNameFromLink(event) {
            let targetElement = event.target
            // Traverse up the DOM tree until we find an <a> ('A') tag or reach the root
            while (targetElement && targetElement.nodeName !== 'A') {
                targetElement = targetElement.parentElement
            }
            if (targetElement && targetElement.nodeName === 'A') {
                let imageHref = decodeURIComponent(targetElement.getAttribute('href'))
                console.log('image href: ', imageHref)
                return this.extractFileNameFromText(imageHref)
            } else {
                return null
            }
        },
        extractFileNameFromText(inputString) {
            // /i matches lower case
            const regex = /\/([\w\s-]+?\.(?:png|jpg|jpeg|pdf))/i;
            const match = regex.exec(inputString);
            // this bit is not redundant; it catches the first version which has a preceding '/'
            if (match && match.length > 1) {
                return match[1];
            } else {
                return null;
            }
        },
        extractAttachmentIdForFileName(fileName, attachments) {
            const matchingAttachment = attachments.find(attachment => attachment.fileName === fileName);
            if (matchingAttachment) {
                console.log('return attachment.id: ', matchingAttachment.id);
                return matchingAttachment.id;
            } else {
                console.log('Attachment not found for fileName:', fileName);
                return null;
            }
        },
        async fetchFullScaleImage(incidentId, attachmentId, fileName) {
            // add try -catch
            let response = await UserService.getAttachment(incidentId, attachmentId);
            return {
                fileName: fileName,
                url: URL.createObjectURL(response.data)
            }
        },
        // ***  end image preview  ***

        processForm() {
            this.error = "";
            if (this.newComment.length <= 16) {
                this.errorComment = "Bitte geben Sie einen Text mit mindestens 10 Zeichen ein!";
                return false;
            }
            this.disabled = true;
            let newComment = this.formatIncidentText(this.newComment);
            if (this.dropzoneFiles.length > 0) {
                try {
                    UserService.createAttachment(this.incidentId, this.dropzoneFiles);
                } catch (e) {
                    this.error = e.message;
                    return false
                }
            }
            UserService.updateIncident(this.incidentId, newComment).then(
                response => {
                    this.getIncident(response.data.id);
                    this.error = '';
                },
                error => {
                    this.getError(error);
                }
            );

            this.dropzoneInstance['dropzone'].removeAllFiles();
            this.dropzoneFiles = [];
            this.newComment = '';
            this.errorComment = '';
        },
        processClosing() {
            this.error = "";
            if (this.closeText.length <= 16) {
                this.errorCloseText = "Bitte geben Sie einen Text mit mindestens 10 Zeichen ein!";
                return false;
            }
            this.disabled = true;
            this.closeText = this.formatIncidentText(this.closeText);
            UserService.updateIncident(this.incidentId, this.closeText, 'Geschlossen - nach Rücksprache Kunde').then(
                response => {
                    this.getIncident(response.data.id);
                    this.error = '';
                },
                error => {
                    this.getError(error);
                }
            );
            this.closeText = '';
            this.errorCloseText = '';
        },
        processReOpening() {
            this.error = "";
            if (this.openText.length <= 16) {
                this.errorOpenText = "Bitte geben Sie einen Text mit mindestens 10 Zeichen ein!";
                return false;
            }
            this.disabled = true;
            this.openText = this.formatIncidentText(this.openText);
            if (this.dropzoneFiles.length > 0) {
                try {
                    UserService.createAttachment(this.incidentId, this.dropzoneFiles);
                } catch (e) {
                    this.error = e.message;
                    return false
                }
            }
            UserService.updateIncident(this.incidentId, this.openText, 'In Bearbeitung').then(
                response => {
                    this.getIncident(response.data.id);
                    this.error = '';
                },
                error => {
                    this.getError(error);
                }
            );

            this.dropzoneFiles = [];
            this.openText = '';
            this.errorOpenText = '';
        },
        getFile(incidentId, attachmentId, fileName) {
            UserService.getAttachment(incidentId, attachmentId).then(
                response => {
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}));
                    var fileLink = document.createElement('a');
                    fileLink.href = url;
                    fileLink.target = '_blank';
                    fileLink.download = fileName;
                    fileLink.click();
                    this.error = '';
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getIncident(id) {
            UserService.getIncident(id).then(
                response => {
                    this.disabled = false;
                    this.incidentId = response.data.id;
                    this.incident = response.data;
                    this.request = response.data.requests.data[0];
                    this.actions = response.data.actions.data.concat(response.data.attachments.data);
                    this.actions.sort(this.sortDate);
                    this.error = '';
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        sortDate(a, b) {
            if (a.entryDate < b.entryDate) {
                return 1;
            }
            if (a.entryDate > b.entryDate) {
                return -1;
            }
            return 0;
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        }
    },
    created() {
        this.getIncident(this.$route.params.id);
    },
    data() {
        return {
            showImagePreview: false, // for modal
            imagePreviewBlob: {},
            imagePreviewBlobs: [],
            downloadLink: null,
            dropzoneInstance: null,
            dropzoneFiles: [],
            dropzoneOptions: {
                dictDefaultMessage: "Klicken Sie hier, oder legen Sie Dateien hier ab um sie hochzuladen",
                dictFallbackMessage: "Ihr Browser unterstützt Drag&Drop Dateiuploads nicht",
                dictFallbackText: "Benutzen Sie das Formular um Ihre Dateien hochzuladen",
                dictFileTooBig: "Die Datei ist zu groß. Die maximale Dateigrösse beträgt {{maxFileSize}}MB",
                dictInvalidFileType: "Eine Datei dieses Typs kann nicht hochgeladen werden",
                dictResponseError: "Der Server hat ihre Anfrage mit Status {{statusCode}} abgelehnt",
                dictCancelUpload: "Hochladen abbrechen",
                dictCancelUploadConfirmation: "Möchten Sie diesen Upload wirklich abbrechen?",
                dictRemoveFile: "Datei entfernen",
                dictMaxFilesExceeded: "Sie können keine weiteren Dateien mehr hochladen",
                paramName: "file",
                autoProcessQueue: false,
                maxFilesize: 2, //2mb


            },
            incident: {
                closed: true,
                actions: [],
            },
            incidentId: 0,
            disabled: true,
            request: {},
            actions: [],
            newComment: '',
            errorComment: '',
            closer: false,
            closeText: '',
            errorCloseText: '',
            reOpener: false,
            errorOpenText: '',
            openText: '',
            error: '',
            value: 1,
            totalIncidents: 1020,
            lastMontIncidents: -3.25,
            errorIncidents: 3.58,
            openIncidents: 6,
            deadIncidents: 2,
            closedIncidents: 114,
            todaysIncidents: 3,
            yesterdayIncidents: 4,
            editor: ClassicEditor,
            editorConfig: {
                language: 'de',
                plugins: [
                    EssentialsPlugin,
                    BoldPlugin,
                    ItalicPlugin,
                    LinkPlugin,
                    ParagraphPlugin,
                    Image,
                    ImageUpload,
                ],
                image: {
                    upload: {
                        types: ['png', 'jpeg', 'bmp', 'gif']
                    }
                },
                extraPlugins: [Base64UploadAdapter],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        '|',
                        'link',
                        'imageUpload',
                        '|',
                        'undo',
                        'redo',
                    ]
                }
            },
        };
    },
};
</script>
<style lang="scss">
b, strong {
    font-weight: bold;
}

.ck-widget.image {
    max-width: 450px;
    max-height: 450px;
}

.card {
    margin-bottom: 20px;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.errorText {
    color: #f5365c;
}

.ck-balloon-panel {
    z-index: 1060 !important;
}

</style>


